import {IconType} from "../Components/ImageMisc/ImageMisc";

export enum Tribe {
    Roman = 1,
    Teuton = 2,
    Gaul = 3,
    Nature = 4,
    Natars = 5,
    Egypt = 6,
    Hun = 7,
    Spartan = 8,
    Viking = 9,
}

export enum TravianBuildingTribe {
    Neutral = 0,
    Roman = 1,
    Teuton = 2,
    Gaul = 3,
    Nature = 4,
    Natar = 5,
    Egypt = 6,
    Hun = 7,
    Spartan = 8,
    Viking = 9,
}

export function tribeToImageString(tribe: Tribe): IconType {
    switch (tribe) {
        case Tribe.Roman: return 'roman';
        case Tribe.Teuton: return 'teuton';
        case Tribe.Gaul: return 'gaul';
        case Tribe.Egypt: return 'egyptian';
        case Tribe.Hun: return 'hun';
        case Tribe.Spartan: return 'spartan';
        case Tribe.Viking: return 'viking';
        default: return 'roman';
    }
}

export default Tribe;
